/* eslint-disable sonarjs/no-angular-bypass-sanitization */
import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({ name: 'safeUrl', })
export class SafeUrlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
